export default __webpack_public_path__ + "static/media/m2.7e46c6c9.png";